var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 8L10 13L15 18","stroke":"#262626","strokeOpacity":"0.7","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Next.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Next;

Next.default = Next;
